<div class="col-md-12">
  <div *ngIf="busy" class="col-md-12 text-center">
    <img src="./assets/images/preloader.gif" />
  </div>
  <div class="col-md-12" *ngIf="!busy">
    <div class="row mb-3 cjgrid-header">
      <div class="col-md-3 cjgrid-title">
        <h4><strong>{{title}}</strong></h4>
      </div>
      <div class="col-md-6 text-right">
        <button *ngFor="let button of buttons" class="btn {{button.class}}" (click)="button.click()"><i class="fas {{button.icon}}"></i> {{button.text}}</button>

      </div>
      <div class="col-md-3">
        <form class="contact-search">
          <div class="form-group">
            <input type="text" class="form-control" name="search" placeholder="Search" (keyup)="search()" [(ngModel)]="searchText" [ngModelOptions]="{standalone: true}">
          </div>
        </form>
      </div>
    </div>
  </div>
  <table class="cjgrid-table" *ngIf="!busy">
    <thead>
    <tr>
      <td *ngFor="let col of columns; let i = index">
        {{col.headerName}}
        <a href="javascript:void(0)" *ngIf="col.sortable" class="sort sort-desc" (click)="sort($event)" [attr.data-index]="i"><i class="fas fa-chevron-down"></i></a>
        <a href="javascript:void(0)" *ngIf="col.sortable" class="sort sort-asc hide" (click)="sort($event)" [attr.data-index]="i"><i class="fas fa-chevron-up"></i></a>
      </td>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let row of rows">
      <td *ngFor="let cell of row"><div [innerHTML]="cell"></div></td>
    </tr>
    </tbody>
  </table>
  <div class="col-md-12 text-center cj-grid-pager" *ngIf="!busy">
    <a href="javascript:void(0)" (click)="firstPage()" [class.disabled]="currentPage==0"><i class="fas fa-chevron-left"></i><i class="fas fa-chevron-left"></i> </a>
    <a href="javascript:void(0)" (click)="prevPage()" [class.disabled]="currentPage==0"><i class="fas fa-chevron-left"></i></a>
    <span>PAGE </span> <span>{{currentPage + 1}} </span> <span>of </span> 	<span>{{totalPages}}</span>
    <a href="javascript:void(0)" (click)="nextPage()" [class.disabled]="currentPage + 1 == totalPages"><i class="fas fa-chevron-right"></i></a>
    <a href="javascript:void(0)" (click)="lastPage()" [class.disabled]="currentPage + 1 == totalPages"><i class="fas fa-chevron-right"></i><i class="fas fa-chevron-right"></i></a>
  </div>
</div>
